import { createAction, props } from '@ngrx/store';
import {
  AppProfile,
  Conversation,
  FileStatus,
  Profile,
  Subscription,
  Workflow,
  WorkflowPayload,
} from '../types/types';

// Subscription

export const getSubscription = createAction(
  '[Workflow] Get subscription data from db',
);

export const saveSubscription = createAction(
  '[Workflow] Save subscription data in store',
  props<{ subscription: Subscription }>(),
);

export const loadedSubscription = createAction(
  '[Loaded] Loaded subscription data from db',
);

export const resetSubscription = createAction(
  '[Loaded] Reset subscription in store',
);

export const getLoadedState = createAction(
  '[Loaded] Loading subscription data from db',
);

// Profile

export const getProfile = createAction('[Workflow] Get Profile data from db');

export const saveProfile = createAction(
  '[Workflow] Save Profile data in store',
  props<{ profile: Profile }>(),
);

export const updateAppProfileByKey = createAction(
  '[Workflow] Update Profile data in store by key',
  props<{ key: string; value: string }>(),
);

export const updateAppProfile = createAction(
  '[Workflow] Update Profile data in store',
  props<{ appProfile: AppProfile }>(),
);

export const saveAppProfile = createAction(
  '[Workflow] Save AppProfile data in store',
  props<{ appProfile: AppProfile }>(),
);

export const loadedProfile = createAction(
  '[Loaded] Loading Profile data from db',
);

// Conversation / GenAi

export const askGenAi = createAction(
  '[Workflow] Process request with GenAi',
  props<{
    conversation: Conversation[];
    responseKey: string | string[];
    processKey: string;
  }>(),
);

export const saveResultToWorklow = createAction(
  '[Workflow] Save model response data in store',
  props<{
    modelResponse: { [key: string]: string };
  }>(),
);

// Workflow

export const createWorkflow = createAction(
  '[Workflow] Create new entry in firestore if sub id does not exist.',
);

export const getWorkflow = createAction(
  '[Workflow] Get stored workflow data based on workflow id.',
  props<{ workflowId: string }>(),
);

export const deleteWorkflow = createAction(
  '[Workflow] Delete stored workflow data based on workflow id.',
  props<{ workflowId: string }>(),
);

export const removeWorkflowById = createAction(
  '[Workflow] Remove workflow data by id',
  props<{ workflowId: string }>(),
);

export const saveWorkflow = createAction(
  '[Workflow] Store workflow data',
  props<{ workflowPayload: WorkflowPayload; workflowId: string }>(),
);

export const updateWorkflow = createAction(
  '[Workflow] Update workflow data',
  props<{ workflow: Workflow }>(),
);

export const loadedWorkflow = createAction(
  '[Loaded] Loading Workflow data from db',
);

export const setErrorState = createAction(
  '[Error] Set error state',
  props<{ error: boolean }>(),
);

// Process
export const getProcessStatus = createAction(
  '[Workflow] Get process status from backend server',
  props<{ processId: string }>(),
);

// Upload

export const uploadFile = createAction(
  '[Workflow] Upload file to backend server',
  props<{ file: File; workflow: Workflow }>(),
);

export const deleteFile = createAction(
  '[Workflow] Delete file from backend server',
  props<{ file: FileStatus; workflow: Workflow }>(),
);

export const saveFileToWorkflow = createAction(
  '[Workflow] Save file to workflow',
  props<{ process: FileStatus; workflow?: Workflow }>(),
);

export const removeFileFromWorkflow = createAction(
  '[Workflow] Remove file from workflow',
  props<{ file: FileStatus; workflow?: Workflow }>(),
);
